module.exports = __webpack_public_path__ + "static/media/bensound-funkyelement.f9c53eae.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/component/music/bensound-funkyelement.mp3
// module id = 858
// module chunks = 0